import Component from '../abstracts/Component';

export default class AddToWishlistComponent extends Component {

  get SELECTORS() {
    return {
      wishlistButton: '.js-wishlist-cta',
      wishlistButtonPdp: '.product-actions.in-pdp .js-wishlist-cta',
      wishlistItem: '.wishlist-item',
      removeFromWish: '.js-remove-wish',
      notAdded: '.js-addtowish',
      added: '.js-added-wish'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      on: 'icon-wishlist-on js-added-wish',
      off: 'icon-wishlist-off js-addtowish'
    };
  }

  constructor() {
    super();
    this.notAdded = $(this.SELECTORS.notAdded);
    this.added = $(this.SELECTORS.added);
  }


  bindEvents() {

    let ctx = this;

    //click on wishlist
    $('body').on('click.addtowish', ctx.SELECTORS.notAdded, function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtowish, $this)
    })

    $('body').on('click.removefromwish', ctx.SELECTORS.added, function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, $this)
    })

    // handler per evento size changed sui bottoni add/remove wishlist
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({
      event,
      payload
    }) => {
      // for the pdp page
      if (!payload.isWishlist) {
        ctx.log('Wishlist item updated');
        $.ajax({
          url: "/action/ajax/wishlist-check-product",
          data: {
            code: payload.code
          },
          success: function (result) {
            let $wishlistButtonPdp = $(ctx.SELECTORS.wishlistButtonPdp);
            $wishlistButtonPdp.attr('data-code', payload.code);
            if(result == "true"){
              // console.log('è nella wishlist');
              $wishlistButtonPdp.attr('data-source', 'size-check');
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, $wishlistButtonPdp);
            }else{
              // console.log('NON è nella wishlist');
              $wishlistButtonPdp.attr('data-source', 'size-check');
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, $wishlistButtonPdp);
            }
          }
        });
      }

    })

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, (e) => {
      let code = $(e.payload).attr('data-code');
      let $cta = $(`${this.SELECTORS.wishlistButton}[data-code=${code}]`);
      $cta.removeClass(this.CLASSES.off).addClass(this.CLASSES.on);
      $cta.attr('data-href', `/action/miniwishlist/remove?productCode=${code}`)
    })

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      let code = $(e.payload).attr('data-code');
      let $cta = $(`${this.SELECTORS.wishlistButton}[data-code=${code}]`);
      $(`${this.SELECTORS.wishlistButton}[data-code=${code}]`).removeClass(this.CLASSES.on).addClass(this.CLASSES.off);
      $cta.attr('data-href', `/action/ajax/wishlist-add`)
    })

  }

  render() {
    this.bindEvents();
  }
}
